import { runLambda, LAMBDA } from './httpClient.js';


async function uploadFileToS3(presignedUrl, file) {
    console.log('uploadFileToS3 - presignedUrl:',presignedUrl)
    const res = await fetch(presignedUrl, {
        method: "PUT",
        headers: {
            "Content-Type": file.type,
            "Content-Disposition": "inline"
        },
        body: file
    });
    if (!res.ok) {
        throw new Error(`File upload failed: ${res.statusText}`);
    }
}


function encodeFileUrl(fileUrl) {
    const parts = fileUrl.split('/');
    parts.push(encodeURIComponent( parts.pop() ) );
    return parts.join('/') ;
}


export async function handleFileUploads(dataType, record) {
    console.log('entered handleFileUploads - record:', record);

    if (!record.savedFiles || !Array.isArray(record.savedFiles)) return;

    const updatedFiles = [];
    const filesToUpload = [];
    const urlsToDelete = [];

    for (const fileItem of record.savedFiles) {

        // Case 1: File marked for deletion — delete from S3
        if (fileItem._markedForDeletion && fileItem.url) {
            urlsToDelete.push(fileItem.url);
            continue;
        }

        // Case 2: New file to upload — defer upload until batch
        if (fileItem.file && !fileItem.url ) {
            // add a uuid to the record before defering it.
            fileItem.uuid = crypto.randomUUID() ;
            filesToUpload.push(fileItem);

        } else if (fileItem.url) {
        // Case 3: Existing uploaded file — keep it
            updatedFiles.push({
                displayText: fileItem.displayText,
                url: fileItem.url
            });
        }
    }

    // delete files from S3 in bulk
    if (urlsToDelete && urlsToDelete.length>0 )
        await deleteFromS3UsingUrl(urlsToDelete); // NOW IMPLEMENTED


    // Upload new files in batch
    if (filesToUpload.length > 0) {
        const uuidListPayload = filesToUpload.map(f => ({ uuid: f.uuid, contentType: f.file.type }));
        console.log('handleFileUploads - uuidListPayload:', uuidListPayload);
        const presignRes = await runLambda(LAMBDA.PRESIGNER, JSON.stringify({
            userId: record.userId,
            recordId: record.recordId,
            //sending uuids and contentType
            uuidList: uuidListPayload
        }));
        const signedUrls = await presignRes.json();
        console.log('handleFileUploads - signedUrls:', signedUrls);

        for (const signed of signedUrls) {
            const match = filesToUpload.find(f => f.uuid === signed.uuid);
            if (!match) continue;

            await uploadFileToS3(signed.presignedUrl, match.file);

            updatedFiles.push({
                displayText: match.displayText || match.file.name,
                url: signed.fileUrl
            });

            delete match.file; // Clean up local object
        }
    }

    // Replace savedFiles in record with cleaned, final list
    record.savedFiles = updatedFiles;
}



export async function getFileUrl(fileUrl) {

    console.log( 'getFieUrl for:', fileUrl ) ;

    const presignRes = await runLambda(LAMBDA.PRESIGNER,
                                       JSON.stringify({ operation: "get", fileUrl: encodeFileUrl(fileUrl) }) );

    if (!presignRes.ok) {
        throw new Error("Failed to generate download link");
    }

    const presignedUrl = await presignRes.json();
    console.log('getFileUrl - returning:',presignedUrl) ;
    return presignedUrl.presignedUrl;
}



export async function deleteFromS3UsingUrl(urlsToDelete) {

    console.log( 'deleteFromS3UsingUrl for:', urlsToDelete ) ;

    const res = await runLambda( `${LAMBDA.DELETES3FILE}`,
                                JSON.stringify({ urlsToDelete }) );

    if (!res.ok) throw new Error("Failed to delete file");

    const retVal = await res.json();
    console.log('deleteFromS3UsingUrl - returning:',retVal) ;
    return retVal;
}

